import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { every, isEqual } from 'lodash';
/**
 * WordPress dependencies
 */

import { Component } from '@wordpress/element';
import { createHigherOrderComponent } from '@wordpress/compose';
export default (function (mapNodeToProps) {
  return createHigherOrderComponent(function (WrappedComponent) {
    return (
      /*#__PURE__*/
      function (_Component) {
        _inherits(_class, _Component);

        function _class() {
          var _this;

          _classCallCheck(this, _class);

          _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
          _this.nodeRef = _this.props.node;
          _this.state = {
            fallbackStyles: undefined,
            grabStylesCompleted: false
          };
          _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
          return _this;
        }

        _createClass(_class, [{
          key: "bindRef",
          value: function bindRef(node) {
            if (!node) {
              return;
            }

            this.nodeRef = node;
          }
        }, {
          key: "componentDidMount",
          value: function componentDidMount() {
            this.grabFallbackStyles();
          }
        }, {
          key: "componentDidUpdate",
          value: function componentDidUpdate() {
            this.grabFallbackStyles();
          }
        }, {
          key: "grabFallbackStyles",
          value: function grabFallbackStyles() {
            var _this$state = this.state,
                grabStylesCompleted = _this$state.grabStylesCompleted,
                fallbackStyles = _this$state.fallbackStyles;

            if (this.nodeRef && !grabStylesCompleted) {
              var newFallbackStyles = mapNodeToProps(this.nodeRef, this.props);

              if (!isEqual(newFallbackStyles, fallbackStyles)) {
                this.setState({
                  fallbackStyles: newFallbackStyles,
                  grabStylesCompleted: !!every(newFallbackStyles)
                });
              }
            }
          }
        }, {
          key: "render",
          value: function render() {
            var wrappedComponent = createElement(WrappedComponent, _extends({}, this.props, this.state.fallbackStyles));
            return this.props.node ? wrappedComponent : createElement("div", {
              ref: this.bindRef
            }, " ", wrappedComponent, " ");
          }
        }]);

        return _class;
      }(Component)
    );
  }, 'withFallbackStyles');
});
//# sourceMappingURL=index.js.map